import React from 'react';
import { useParams } from 'react-router-dom';
import PublicWebsitePage from './PublicWebsitePage';
import PublicWebsiteHomePage from './PublicWebsiteHomePage';

function PublicWebsiteByDomainSlugRoute() {
  const { slug } = useParams();

  if ((slug ?? '').trim().toLowerCase() === 'home') {
    return <PublicWebsiteHomePage />;
  }

  return <PublicWebsitePage />;
}

export default PublicWebsiteByDomainSlugRoute;
